var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapsible-tidy-tree",attrs:{"id":"tree-content"}},[_c('svg',{attrs:{"id":"tree-content-svg","width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }